module.exports = __webpack_public_path__ + "img/coins.c3d6febb.svg";